export default __webpack_public_path__ + "static/media/great.f313fa3a.png";